import { Component, inject, input } from "@angular/core";
import { DialogRef } from "@angular/cdk/dialog";
import { FormsModule } from "@angular/forms";

import { httpErrorMessage } from "../../../_helpers/http-error-message";
import { normalizeXid, xidToEpc } from "../../../_helpers/xid";
import { XidOwnerType, XidService } from "../../../_services/xid.service";

// Umschlüsseln eines RFID-Etiketts (bentomax/hawk#605): neue XID vergeben, die
// alte sperrt der Server dauerhaft. Schließt mit true, wenn gespeichert wurde.
@Component({
  selector: "hawk-xid-rekey-dialog",
  standalone: true,
  imports: [FormsModule],
  templateUrl: "./xid-rekey-dialog.component.html",
})
export class XidRekeyDialogComponent {
  ownerType = input.required<XidOwnerType>();
  ownerId = input.required<number>();
  currentXid = input<string | null>(null);

  protected dialogRef = inject<DialogRef<boolean>>(DialogRef);
  private xidService = inject(XidService);

  protected newXid = "";
  protected reason = "";
  protected saving = false;
  protected errorMessage: string | null = null;

  /** Normalform der Eingabe oder null, solange sie keine gültige XID ist */
  protected get normalizedXid(): string | null {
    return normalizeXid(this.newXid);
  }

  protected get newEpc(): string | null {
    return xidToEpc(this.normalizedXid);
  }

  protected get canSave(): boolean {
    return !this.saving && this.normalizedXid !== null && this.normalizedXid !== this.currentXid();
  }

  /** Beim Verlassen des Felds auf die Normalform bringen */
  protected normalizeInput() {
    if (this.normalizedXid) {
      this.newXid = this.normalizedXid;
    }
  }

  protected save() {
    if (!this.canSave) return;

    this.saving = true;
    this.errorMessage = null;
    this.xidService
      .rekey({
        owner_type: this.ownerType(),
        owner_id: this.ownerId(),
        new_xid: this.normalizedXid,
        reason: this.reason.trim() || null,
      })
      .subscribe({
        next: () => {
          this.saving = false;
          this.dialogRef.close(true);
        },
        error: (error) => {
          this.saving = false;
          this.errorMessage = httpErrorMessage(error, "Die XID konnte nicht geändert werden.");
        },
      });
  }
}
